import {
  Delete,
  Edit,
  PinDrop,
  PinDropTwoTone,
  WalletOutlined,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import { useNavigate } from "react-router-dom";
import { REDIRECT_PATH } from "../../../../Routes";
import RiderContext from "../../../../context/RiderContext/RiderContext";
import {
  Delete_Rider,
  Enable_Disable_Rider,
  Get_Details_Rider,
} from "../../../../Apis/riderApi/RiderApi";
import { Calendar } from "react-feather";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";

const RiderDataTabelContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
    setAspect,
  } = useContext(RiderContext);
  const { isLoading, data, refetch } = props;
  const history = useNavigate();

  /**
   * get rider Details
   */
  const { mutate: riderDetails, isLoading: isLoadingriderDetails } =
    useMutation((riderId) =>
      Get_Details_Rider(riderId, history, setFormData, setAspect)
    );

  const GetRider = (riderId) => {
    riderDetails(riderId);
    setId(riderId);
    setIsEdit(false);
  };

  /**
   * delete rider
   */
  const { mutate: riderDelete, isLoading: isLoadingDelete } = useMutation(
    (riderId) => Delete_Rider(riderId, refetch)
  );

  const DeleteRider = async (riderId) => {
    let { isConfirmed } = await SweetConfirmation();
    if (isConfirmed) {
      riderDelete(riderId);
    }
  };

  /**
   * enable / disable rider
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Rider(formData, refetch)
  );

  const handleRiderStatusChange = (riderId, status) => {
    let formDate = {
      riderId: riderId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.riderId === riderId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const handleOpenandClosePopup = () => {
    history(`${REDIRECT_PATH.RIDER}/add`);
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 180,
      field: "name",
      headerName: "Name",
      renderCell: (params) =>
        params.row.userDetail?.name ? params.row.userDetail?.name : "--",
    },
    // {
    //   flex: 0.1,
    //   minWidth: 250,
    //   field: "email",
    //   headerName: "Email",
    //   renderCell: (params) =>
    //     params.row?.userDetail?.email ? (
    //       <div
    //         className="m-0"
    //         style={{
    //           width: "11rem",
    //         }}
    //       >
    //         {params.row?.userDetail?.email}
    //       </div>
    //     ) : (
    //       "--"
    //     ),
    // },
    {
      flex: 0.1,
      minWidth: 120,
      field: "phone",
      headerName: "Phone",
      renderCell: (params) =>
        params.row?.userDetail?.phone
          ? params.row?.userDetail?.dialCode + params.row?.userDetail?.phone
          : "--",
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleRiderStatusChange(params.row.riderId, params.row.isActive)
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "isOnline",
      headerName: "Rider Status",
      renderCell: (params) =>
        params.row?.isOnline ? (
          <span
            style={{
              color: "green",
              fontWeight: "700",
              letterSpacing: "0.8px",
            }}
          >
            Online
          </span>
        ) : (
          <span
            style={{ color: "red", fontWeight: "700", letterSpacing: "0.8px" }}
          >
            Offline
          </span>
        ),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "isBusy",
      headerName: "Rider Busy",
      renderCell: (params) =>
        params.row?.isBusy ? (
          <span
            style={{
              color: "red",
              fontWeight: "700",
              letterSpacing: "0.8px",
            }}
          >
            Yes
          </span>
        ) : (
          <span
            style={{
              color: "green",
              fontWeight: "700",
              letterSpacing: "0.8px",
            }}
          >
            No
          </span>
        ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 350,
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: (params) => (
        <>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                onClick={() => GetRider(params.row.riderId)}
              >
                <Edit style={{ color: "#7366ff" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Online - Offline history">
              <IconButton
                aria-label="Online-Offline-history"
                onClick={() => history(`/rider-on-off/${params.row.riderId}`)}
              >
                <DoneAllOutlinedIcon style={{ color: "#f59e0b" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Date wise order delivered">
              <IconButton
                aria-label="Online-Offline-history"
                onClick={() =>
                  history(`/rider-assign-order/${params.row.riderId}`)
                }
              >
                <Calendar style={{ color: "#f59e0b" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Wallet History">
              <IconButton
                aria-label="wallet-history"
                onClick={() =>
                  history(`/rider-wallet-history/${params.row.riderId}`)
                }
              >
                <WalletOutlined style={{ color: "#f59e0b" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Rider Location">
              <IconButton
                aria-label="wallet-history"
                onClick={() =>
                  history(
                    `/rider-location/${params.row.latitude}/${params.row.longitude}`
                  )
                }
              >
                <PinDrop style={{ color: "#f59e0b" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Rider Delivery Location">
              <IconButton
                aria-label="wallet-history"
                onClick={() =>
                  history(`/rider-delivery-location/${params.row.riderId}`)
                }
              >
                <PinDropTwoTone style={{ color: "#f59e0b" }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "5px" }}>
            <Tooltip title="Delete">
              <IconButton
                aria-label="delete"
                onClick={() => DeleteRider(params.row.riderId)}
              >
                <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse isLoading={isLoadingriderDetails || isLoadingDelete} />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.riderId}
        addButton={true}
      />
    </Fragment>
  );
};

export default RiderDataTabelContainer;
